export default __webpack_public_path__ + "static/media/bg-detail.4921ebb7.svg";